module.exports = __webpack_public_path__ + "img/apaixonada.83e44276.png";